import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import {
  Grid,
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core'

// actions
import {
  getThirdPartyAccounts,
  updateThirdPartyAccount,
  addNewThirdPartyAccount,
  deleteThirdPartyAccount,
} from '../../../actions/thirdParty'

// utils
import { sortArrayByName } from '../../../utils/array'
import { hasAccess } from '../../../utils/api'

// local components
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import ThirdPartyItemContainer from '../../../components/ThirdParty/ThirdPartyItemContainer'
import ModalDialog from '../../../components/common/ModalDialog'
import { Appcues } from '../../../utils/constants'

const emptyThirdPartyAccount = {
  name: '',
  accountType: 'None',
  username: '',
  password: '',
  active: true,
}

class ThirdPartyAccounts extends PureComponent {
  state = {
    showEmptyThirdPartyAccount: false,
    selectedToDeleteThirdPartyAccount: {},
  }

  componentDidMount() {
    this.props.dispatch(getThirdPartyAccounts())
  }

  onThirdPartyAccountUpdate = (data, afterOnSave) => {
    this.props.dispatch(updateThirdPartyAccount(data)).then((response) => {
      Appcues.track('Updated Third Party Account')
      this.props.dispatch(getThirdPartyAccounts())
      afterOnSave(response)
    })
  }

  openDeleteModal = (thirdPartyAccount) => (e) => {
    this.setState({
      selectedToDeleteThirdPartyAccount: thirdPartyAccount,
    })

    this.deleteModal.handleClickOpen()
  }

  onDeleteThirdPartyAccount = (thirdPartyAccount) => (e) => {
    this.deleteModal.handleClose()

    this.props.dispatch(deleteThirdPartyAccount(thirdPartyAccount.id)).then((response) => {
      Appcues.track('Deleted Third Party Account')
      this.props.dispatch(getThirdPartyAccounts())
    })
  }

  toggleEmptyThirdPartyAccount = () => {
    Appcues.track('Adding Third Party Account')
    this.setState((prevState) => ({
      showEmptyThirdPartyAccount: !prevState.showEmptyThirdPartyAccount,
    }))
  }

  addNewThirdPartyAccount = (data, afterOnSave) => {
    const { session = {} } = this.props.authReducer

    const { assignedShop = {} } = session

    this.props
      .dispatch(addNewThirdPartyAccount({ ...data, shopId: assignedShop.id }))
      .then((thirdPartyAccount) => {
        Appcues.track('Added Third party account')
        this.props.dispatch(getThirdPartyAccounts())
        this.toggleEmptyThirdPartyAccount()
      })
  }

  render() {
    const { thirdPartyAccounts = {}, lastModified = null } = this.props.thirdPartyReducer

    const { showEmptyThirdPartyAccount, selectedToDeleteThirdPartyAccount } = this.state
    const thirdPartyAccountsValues = sortArrayByName(thirdPartyAccounts.values || [])
    const permitted = hasAccess()
    return (
      <div>
        <Grid container>
          <Grid className="addButton" item xs={12} sm={12} md={12} lg={12}>
            {permitted ? (
              <Button
                variant="raised"
                className="primary-button pull-right margin-bottom-small"
                onClick={this.toggleEmptyThirdPartyAccount}
              >
                Add Account
              </Button>
            ) : null}
          </Grid>
        </Grid>
        <Grid container>
          <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
            <Paper className="thirdParty">
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Name</TableCell>
                      <TableCell>Account</TableCell>
                      <TableCell>User Name</TableCell>
                      <TableCell>Password</TableCell>
                      <TableCell>Status</TableCell>
                      {permitted ? <TableCell></TableCell> : null}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {showEmptyThirdPartyAccount ? (
                      <ThirdPartyItemContainer
                        thirdPartyAccount={emptyThirdPartyAccount}
                        lastModified={lastModified}
                        onThirdPartyAccountUpdate={this.addNewThirdPartyAccount}
                        onCancel={this.toggleEmptyThirdPartyAccount}
                        defaultEditMode={true}
                      />
                    ) : null}
                    {thirdPartyAccountsValues.map((row, index) => {
                      return (
                        <ThirdPartyItemContainer
                          key={index}
                          thirdPartyAccount={row}
                          lastModified={lastModified}
                          onThirdPartyAccountUpdate={this.onThirdPartyAccountUpdate}
                          onDelete={this.openDeleteModal(row)}
                        />
                      )
                    })}
                  </TableBody>
                </Table>
              </div>
            </Paper>
          </Grid>
          <ModalDialog
            ref={(c) => (this.deleteModal = c)}
            onConfirm={this.onDeleteThirdPartyAccount(selectedToDeleteThirdPartyAccount)}
            confirmText="delete"
          >
            Are you sure you want to delete '{selectedToDeleteThirdPartyAccount.name}'
          </ModalDialog>
        </Grid>
      </div>
    )
  }
}

export default connect(({ dispatch, authReducer, thirdPartyReducer }) => ({
  dispatch,
  authReducer,
  thirdPartyReducer,
}))(ContainerWithTitle(ThirdPartyAccounts, 'Third Party Accounts'))



// WEBPACK FOOTER //
// ./src/containers/Settings/ThirdParty/index.js